/**
 * cache 模块处理运行时缓存的数据
 * @module cache
 */

let cache = {};

export function getCache (key) {
  if (!key) {
    console.warn('[cache.getCache() warn]: cacheKey 为空');
  }

  return cache[key];
}
 
export function setCache (key, value) {
  if (!key) {
    console.warn('[cache.setCache() warn]: cacheKey 为空');
    return;
  }

  cache[key] = value;
}
 
export function removeCache (key) {
  if (!key) {
    console.warn('[cache.removeCache() warn]: cacheKey 为空');
    return;
  }

  delete cache[key];
}
 
export function resetAllCache () {
  cache = {};
  console.log('[cache.resetAllCache() success]: App cache 已被重置');
}
